var React = require('react');

function ButtonNextRightLargeInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M27 54C41.9117 54 54 41.9117 54 27C54 12.0883 41.9117 0 27 0C12.0883 0 0 12.0883 0 27C0 41.9117 12.0883 54 27 54Z","fill":"#0A9E50","key":0}),React.createElement("path",{"d":"M27 39.5C33.9036 39.5 39.5 33.9036 39.5 27C39.5 20.0964 33.9036 14.5 27 14.5C20.0964 14.5 14.5 20.0964 14.5 27C14.5 33.9036 20.0964 39.5 27 39.5Z","stroke":"white","strokeWidth":"1.5","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M25.4248 31.4125L29.8248 27L25.4248 22.5875","stroke":"white","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

ButtonNextRightLargeInline.defaultProps = {"width":"54","height":"54","viewBox":"0 0 54 54","fill":"none"};

module.exports = ButtonNextRightLargeInline;

ButtonNextRightLargeInline.default = ButtonNextRightLargeInline;
